import { render } from "./TextChangeHistoryButton.vue?vue&type=template&id=8d262080&scoped=true"
import script from "./TextChangeHistoryButton.vue?vue&type=script&lang=js"
export * from "./TextChangeHistoryButton.vue?vue&type=script&lang=js"

import "./TextChangeHistoryButton.vue?vue&type=style&index=0&id=8d262080&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d262080"]])

export default __exports__